export interface IOptOutModel {
    name: string;
    position: string;
    company: string;
    reason: string;
    updated_at?: string;
}
